/**
 * Stores build information. The string literals are replaced at compile time by `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-08-12",
    versionChannel: "nightly",
    buildDate: "2024-08-12T00:05:51.784Z",
    commitHash: "bf55f15913d655e66505ee68deecf4c94dc8dc98",
};
